import React, { useContext, useEffect, useState } from 'react';
import FavouriteAccounts from './FavouriteAccounts';
import AllAccounts from './AllAccounts';
import { AccountListContext } from '../../../context/AccountListContext';
import './Accounts.css';
import useAuth from '../../../hooks/useAuth';
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import { useLocation, useParams } from 'react-router-dom';
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from '../../../services/commonService';
import { useUser } from '../../../context/UserContext';
import AllSalesAccounts from './AllSalesAccounts';

export default function SalesAccounts() {

    useAuth();
    var currentUrl = useLocation().pathname;
    const [loader, setLoader] = useState(false);
    const context = useContext(AccountListContext);
    const { loading } = context;
    const { user } = useUser();
    const [currentRoleKey, setCurrentRoleKey] = useState(user?.role_key);

    if(user?.role_key == "CLIENT" || user?.role_key == "CLIENT_EMPLOYEE"){
      window.location.replace('/clients_accounts');
    }

    const pageParsedData = getUrlDetailsObj(useLocation, useParams);

    useEffect(() => {
      if(user?.company_id){
          const userStat = getUserStatsObject("Companies", "page_load", "Page Source: Companies", currentUrl);
          userStat.url_details = pageParsedData;
          recordActivity(userStat);
      }
    }, [user?.company_id])

    useEffect(() => {
      setCurrentRoleKey(user?.role_key);
    }, [user?.role_key])

    useEffect(() => {
      setLoader(loading);
    }, [loading]);

    return (
        <div className='container-fluid'>
          {loader && <ScreenLoader />}
            
            <div className='row'>
                <AllSalesAccounts />
            </div>
            
        </div>
    );
}
